import { render, staticRenderFns } from "./plugin_update.vue?vue&type=template&id=9845f268&"
import script from "./plugin_update.vue?vue&type=script&lang=ts&"
export * from "./plugin_update.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports